import type { HeroHeaderView } from "@opensea/navigation"
import type { TopNavbarVariants } from "../navigation/top-nav/TopNavbarContainer"

export const topNavbarVariantsForHeroHeaderView = (
  heroHeaderView: HeroHeaderView,
): TopNavbarVariants => {
  return {
    transparent: "always",
    dark: heroHeaderView === "full",
    gradient: heroHeaderView === "full",
  }
}
